<script lang="ts">
  import { Heading } from 'flowbite-svelte'
  import type { Snippet } from 'svelte'
  import { readerFontFamily } from '$lib/reader-fonts'
  import { readerOpts } from '$lib/store'

    interface Props {
      depth: 1|2|3|4|5|6
      raw: string
      text: string
      options: any
      slug: (val: string) => string // trunk-ignore(eslint/no-unused-vars)
      children?: Snippet
    }

    const { depth, raw, text, options, slug, children }: Props = $props()
    const id = $derived(options.headerIds ? options.headerPrefix + slug(text) : undefined)
    const sizes = {
    1: "text-5xl",
    2: "text-4xl",
    3: "text-3xl",
    4: "text-2xl",
    5: "text-2xl",
    6: "text-2xl",
  }

</script>

{#key $readerOpts}
<Heading tag="h{depth}" class="{sizes[depth]} mt-10 mb-2"
style="
 font-family: {readerFontFamily($readerOpts.bodyFont)};
 margin-inline: {($readerOpts.margin?.novel ?? 0) / 2}%;
  "
>
  {@render children()}
</Heading>
{/key}
